export const SHOW_MODAL = 'SHOW_MODAL';

export default {
  namespaced: true,
  state: {
    show: false,
  },
  getters: {
    modal: state => state.show,
  },
  mutations: {
    [SHOW_MODAL](state, bool) {
      state.show = bool;
    },
  },
  actions: {
    showModal({ commit }, bool) {
      if (bool) document.body.setAttribute('style', 'overflow: hidden');
      else document.body.removeAttribute('style');

      commit(SHOW_MODAL, bool);
    },
  },
};
